/**
 * SearchTrending 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * SearchTrending
 */
export interface SearchTrending {
  /** 创建时间（UTC） */
  created_at?: string
  /** 更新时间（UTC） */
  updated_at?: string
  /** 主键（UUID4），全局唯一，不可重复，36位 */
  id?: string
  /** 搜索关键词 */
  keyword?: string
  /** 关键词哈希 */
  keyword_hash?: string
  /** 统计周期类型 */
  period_type?: string
  /** 周期起始时间 */
  period_start?: string
  /** 当天搜索次数 */
  search_count?: number
  /** 当天搜索的唯一用户数 */
  unique_users?: number
  /** 当日排名 */
  rank?: number
  /** 排名变化（正数上升，负数下降） */
  rank_change?: number
  /** 热度分数 */
  heat_score?: number
  /** 是否新上榜 */
  is_new?: boolean
  /** 是否热搜 */
  is_hot?: boolean
  /** 运营权重调整（-1.0~10.0），用于置顶/推荐/降权 */
  admin_boost?: number
  /** 是否隐藏（运营屏蔽） */
  is_hidden?: boolean
}

/**
 * SearchTrending Schema
 */
export const SearchTrendingSchema: SchemaDefinition = {
  properties: {
    created_at: {
      description: '创建时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '创建时间',
    },
    updated_at: {
      description: '更新时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '更新时间',
    },
    id: {
      description: '主键（UUID4），全局唯一，不可重复，36位',
      format: 'string',
      type: 'string',
      label: '主键',
    },
    keyword: {
      description: '搜索关键词',
      format: 'string',
      type: 'string',
      label: '搜索关键词',
    },
    keyword_hash: {
      description: '关键词哈希',
      format: 'string',
      type: 'string',
      label: '关键词哈希',
    },
    period_type: {
      description: '统计周期类型',
      format: 'cons.StatsPeriodType',
      type: 'string',
      label: '统计周期类型',
    },
    period_start: {
      description: '周期起始时间',
      format: '*time.Time',
      type: 'string',
      label: '周期起始时间',
    },
    search_count: {
      description: '当天搜索次数',
      format: 'int',
      type: 'integer',
      label: '当天搜索次数',
    },
    unique_users: {
      description: '当天搜索的唯一用户数',
      format: 'int',
      type: 'integer',
      label: '当天搜索的唯一用户数',
    },
    rank: {
      description: '当日排名',
      format: 'int',
      type: 'integer',
      label: '当日排名',
    },
    rank_change: {
      description: '排名变化（正数上升，负数下降）',
      format: 'int',
      type: 'integer',
      label: '排名变化',
    },
    heat_score: {
      description: '热度分数',
      format: 'float64',
      type: 'number',
      label: '热度分数',
    },
    is_new: {
      description: '是否新上榜',
      format: 'bool',
      type: 'boolean',
      label: '是否新上榜',
    },
    is_hot: {
      description: '是否热搜',
      format: 'bool',
      type: 'boolean',
      label: '是否热搜',
    },
    admin_boost: {
      description: '运营权重调整（-1.0~10.0），用于置顶/推荐/降权',
      format: 'float64',
      type: 'number',
      label: '运营权重调整',
    },
    is_hidden: {
      description: '是否隐藏（运营屏蔽）',
      format: 'bool',
      type: 'boolean',
      label: '是否隐藏',
    },
  },
  type: 'object',
}
